import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const WarningBanner = () => {
    const [warning, setWarning] = useState({ show: false });
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/";
        useEffect(() => {
            fetch(`${API_URL}warningMessage`)
            .then(res => res.json())
            .then(data => {
            if (data.show) {
            setWarning(data);
            }
        })
            .catch(err => {
            console.error('Failed to fetch warning message:', err);
        });
        }, [API_URL]);

  if (!warning.show) return null;


  return (
      <BannerWrapper type={warning.type}>
      <p>{warning.message}</p>
    </BannerWrapper>
  );
};

export default WarningBanner;

const BannerWrapper = styled.div`
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  padding: 1px;
  background-color: ${props => {
    switch (props.type) {
      case 'error':
        return '#c00a0a';
      case 'warning':
        return '#eed813';
      case 'info':
      default:
        return '#628161ff';
    }
  }};
  color: ${props => (props.type === 'warning' ? 'black' : 'white')};
`;
